import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Decorations = () => (
  <>
    <StaticImage
      className="decoration decoration--leaf1"
      src="../images/decorations/leaf1.png"
      alt="leaf"
      placeholder="none"
    />
    <StaticImage
      className="decoration decoration--leaf2"
      src="../images/decorations/leaf1.png"
      alt="leaf"
      placeholder="none"
    />
    <StaticImage
      className="decoration decoration--leaf3"
      src="../images/decorations/leaf1.png"
      alt="leaf"
      placeholder="none"
    />
    <StaticImage
      className="decoration decoration--leaf4"
      src="../images/decorations/leaf2.png"
      alt="leaf"
      placeholder="none"
    />
  </>
);

export default Decorations;
